import { Chip } from "@/components/atoms/Chip/Chip";
import { t } from "@lingui/core/macro";
import { useState } from "react";
import { CopyButton } from "../CopyButton/CopyButton";
import { TooltipWrapper } from "../TooltipWrapper/TooltipWrapper";
import "./TabChip.scss";

type TabChipProps = {
  label: string;
  onClick?: () => void;
  onCopy?: () => void;
  showCopy?: boolean;
};

export const TabChip = ({ label, onClick, onCopy, showCopy = true }: TabChipProps) => {
  const [copyTooltipVisible, setCopyTooltipVisible] = useState(false);

  const handleCopy = () => {
    onCopy?.();
    setCopyTooltipVisible(true);
    setTimeout(() => setCopyTooltipVisible(false), 2000);
  };

  return (
    <Chip isActive={false} onClick={onClick} className="tab-chip">
      <span className="chip-label">{label}</span>
      {showCopy && (
        <div className="chip-actions">
          <TooltipWrapper
            tooltipText={t`Copied!`}
            position="left"
            tail={true}
            disabled={!copyTooltipVisible}
            delay={100}
          >
            <CopyButton onClick={handleCopy} />
          </TooltipWrapper>
        </div>
      )}
    </Chip>
  );
};
